import React from "react";
import { useParams } from "react-router-dom";
import MetaInfo from "./components/MetaInfo";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollToTop";
import { schoolHeroComponents } from "./school-components/HeroBanners";
import AcademicPrograms from "./school-components/AcademicPrograms";
import schools from "./assets/data/schools";
import SchoolOverview from "./school-components/SchoolOverview";
import WhyChooseSchool from "./school-components/WhyChooseSchools";
import DeansDeskSection from "./school-components/DeansDeskSections";
import { LearningMethodologyRenderer } from "./school-components/LearningMethodologySections";
import OutcomesSections from "./school-components/OutcomesSections";
import { CareerServicesPlacementsRenderer } from "./school-components/CareerServicesPlacementSections";
import FAQSections from "./school-components/FAQSections";
import Footer from "./components/Footer";
import Faculty from "./school-components/Faculty"
import { AdmissionEligibilityRenderer } from "./school-components/AdmissionEligibilitySections";
import ApplyNowFormSection from "./school-components/ApplyNowFormSection";
import Alumni from "./home-components/Alumni";
import OtherSchoolsSection from "./school-components/OtherSchoolsSection";
import FacultyPublicationsSection from "./school-components/FacultyPublicationsSection";

import banner from "./assets/img/schoolbanner/school-of-management.webp";
import learningImage from "./assets/img/management-learning.webp";

const utilityLinks = [
    { title: "Student Login", url: "/student-login" },
    { title: "NAAC", url: "/naac" },
    { title: "IQAC", url: "/iqac" },
    { title: "e-Library", url: "/e-library" },
    { title: "Ph.D Research", url: "/phd-research" },
    { title: "Pay Online", url: "/pay-online" },
];


const SchoolDetails = () => {
    const { schoolName } = useParams();

    const schoolId = "school-of-" + schoolName;
    const HeroComponent = schoolHeroComponents[schoolId];

    const currentSchool = schools.find(
        (item) => item.id === schoolId
    );

    return (
        <>
            <MetaInfo param="school" id={schoolId} />

            <Header school={schoolId} />

            <main className="school-page">
                <HeroComponent
                    exploreHref="#academic-programs"
                    applyHref="/apply-online"
                />

                <SchoolOverview
                    school={schoolId}
                    image={banner}
                />

                <AcademicPrograms school={currentSchool} />

                <WhyChooseSchool
                    school={schoolId}
                    image={banner}
                    href="#academic-programs"
                />

                <DeansDeskSection school={schoolId} />

                <LearningMethodologyRenderer school={schoolId} learningImage={learningImage} />

                <OutcomesSections school={schoolId} />

                <Faculty />

                <FacultyPublicationsSection fileBasePath="/faculty-publications/2026" />

                <CareerServicesPlacementsRenderer school={schoolId} />

                <AdmissionEligibilityRenderer school={schoolId} />

                {/*  STUDENT TESTIMONIALS & SUCCESS STORIES  */}
                <Alumni />

                <FAQSections school={schoolId} />

                <ApplyNowFormSection school={currentSchool} />

                {/* Other Schools */}
                <OtherSchoolsSection />
            </main>
            <Footer />
        </>
    );
};

export default SchoolDetails;
